import { postRequest } from '../clients/axios';
import { SavePlayerPhonePayload, SavePlayerPhoneResponse } from '../models';

export const postSavePlayerPhone = async (data: SavePlayerPhonePayload) => {
  const url = 'player/saveplayerphone';
  const response = await postRequest<SavePlayerPhoneResponse>(url, data);
  return response;
};
